import { InquiryService } from './../../../services/inquiry.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Inquiry, InquiryCategory, InquiryStatusMap } from '../../../models/inquiry.model';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material.module';
import { Router, RouterModule } from '@angular/router';
import { BodyScrollEndEvent, ColDef, ColGroupDef, FilterChangedEvent, FirstDataRenderedEvent, GetRowIdParams, GridReadyEvent, GridState, PaginationChangedEvent, RowNode } from 'ag-grid-community';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { blankOpen, escapeHTML, formatDate } from '../../../misc/functions';
import { FormsModule } from '@angular/forms';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { LabelChipRendererComponent } from '../../label-chip/label-chip-renderer.componemt';
import { AG_GRID_LOCALE_JP } from '../../../misc/ag-grid-locale';
import { CustomSelectFilterComponent, CustomTextFilterComponent } from '../../../misc/custom-filter.component';
import { AdminUser, AdminUsersService } from '../../../services/admin-users.service';
import { MyGridState } from '../../../models/grid-state.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin-inquiry-list',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, AgGridModule, FormsModule, LabelChipRendererComponent],
  templateUrl: './admin-inquiry-list.component.html',
  styleUrls: ['./admin-inquiry-list.component.scss']
})
export class AdminInquiryListComponent implements OnInit {

  localeText = AG_GRID_LOCALE_JP;

  defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    suppressHeaderMenuButton: true,
    suppressFloatingFilterButton: true,
    suppressFiltersToolPanel: true,
    floatingFilterComponent: CustomTextFilterComponent
  };

  columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID', width: 95, sortable: true,
      cellRenderer:      (params: any) => params.data.is_admin_turn ? `★${params.value}` : `${params.value}`,
      filterValueGetter: (params: any) => params.data.is_admin_turn ? `★${params.data.id}` : `${params.data.id}`,
    },
    { field: 'updated_at', headerName: '更新日時', width: 165, valueFormatter: params => formatDate(params.value), sortable: true},
    { field: 'user_id', headerName: 'ユーザー', width: 200, sortable: true,
      cellRenderer: (params: any) => params.data.name ? `${params.data.name} (${params.data.login})` : params.data.login,
      filterValueGetter: (params: any) => params.data.name ? `${params.data.name} (${params.data.login})` : params.data.login
    },
    { field: 'sub_category', headerName: '分類', width: 125,  sortable: true,
      floatingFilterComponent: CustomSelectFilterComponent,
      floatingFilterComponentParams: {
        filterType: 'equals',
        options: [
          {label: '　', value: '　'},
        ]
      }
      // sub_category の floatingFilterComponentParams は遅延設定する
    },
    { field: 'title', headerName: 'タイトル（📄はAIの要約・カーソルを当てて表示）', flex: 1, wrapText: true, autoHeight: true, sortable: true,
      cellRenderer: (params: any) => params.data.first_child_summary ? `<span title="${escapeHTML(params.data.first_child_summary)}" style="display: block; width: 100%; height: 100%; cursor: help;">📄&nbsp;${escapeHTML(params.value)}</span>` : escapeHTML(params.value)
    },
    /*
    { field: 'admin_user_id', headerName: '担当者', width: 110, sortable: true,
      cellRenderer: (params: any) => params.value ? this.adminUsers.find(x => x.id === params.value)?.user_name : '(未割当)',
      floatingFilterComponent: CustomSelectFilterComponent,
      // adminUser の floatingFilterComponentParams は遅延設定する
    },
    */
    { field: 'status', headerName: '状態', width: 120,  cellRenderer: LabelChipRendererComponent, cellStyle: {'text-align': 'center'}, sortable: true,
      floatingFilterComponent: CustomSelectFilterComponent,
      floatingFilterComponentParams: {
        filterType: 'equals',
        options: [
          {label: '　', value: '　'},
        ]
      }
      // status の floatingFilterComponentParams は遅延設定する
    },
    { field: 'priority', headerName: '優先度', width: 100,  cellRenderer: LabelChipRendererComponent, cellStyle: {'text-align': 'center'}, sortable: true,
      floatingFilterComponent: CustomSelectFilterComponent,
      floatingFilterComponentParams: {
        filterType: 'equals',
        options: [
          {label: '通常', value: '通常'},
          {label: '優先', value: '優先'},
          {label: '緊急', value: '緊急'},
        ]
      }
    }
  ];

  InquiryStatusMap = InquiryStatusMap;
  InquiryCategory = InquiryCategory;
  category: typeof InquiryCategory[number] = 'お問い合わせ';

  paginationPageSizeSelector: number[] | boolean = [10, 20, 50, 100];

  showCompleted = false; // デフォルトは「完了は非表示」
  showOnlyUnassigned = false; // デフォルトは「全て表示」

  allRows: Inquiry[] = []; // APIレスポンスを保持
  rowData: Inquiry[] = []; // 表示用データ

  adminUsers: AdminUser[] = [];
  showGrid = false;
  isLoaded = false;

  pageSize: number = 100;

  storageKeyPrefix = 'adminInquiry';
  categoryKey =  this.storageKeyPrefix + 'Category';
  gridStateStorageKey = this.storageKeyPrefix + 'GridState';
  gridPageSizeStorageKey = this.storageKeyPrefix + 'PageSize'
  girdShowOnlyUnassignedStorageKey = this.storageKeyPrefix + 'ShowOnlyUnassigned';
  gridShowCompletedStorageKey = this.storageKeyPrefix + 'ShowCompleted';
  gridScrollStorageKey = this.storageKeyPrefix + 'GridSctoll';

  isGridInitialized = false;

  @ViewChild('grid') grid!: AgGridAngular;

  constructor(
    private service: InquiryService,
    private snackBar: ModalSnackbarService,
    private route: ActivatedRoute,
    private router: Router,
    private adminUsersService: AdminUsersService,
  ) {}

  getRowId = (p: GetRowIdParams) => String(p.data.id);

  onGridReady(e: GridReadyEvent) {
    this.restoreById(e);
  }

  onFirstDataRendered(e: FirstDataRenderedEvent) {
    this.restoreById(e);
  }

  private restoreById(e: GridReadyEvent | FirstDataRenderedEvent) {
    const savedId = sessionStorage.getItem(this.gridScrollStorageKey);
    if (!savedId) return;

    const tryShow = () => {
      const node = e.api.getRowNode(savedId);
      if (node) { e.api.ensureNodeVisible(node, 'middle'); return true; }
      return false;
    };

    if (tryShow()) return;
    const handler = () => { if (tryShow()) e.api.removeEventListener('modelUpdated', handler); };
    e.api.addEventListener('modelUpdated', handler); // データ/フィルタ/ソート後に再挑戦
  }

  restoreGridState(): void {

    const saved = localStorage.getItem(this.gridStateStorageKey);
    if (saved) {
      try {
        const state: MyGridState = JSON.parse(saved);

        // フィルターの復元
        if (state.filterModel) {
          this.grid.api.setFilterModel(state.filterModel);
        }

        // ソートやカラム状態の復元
        if (state.columnState) {
          this.grid.api.applyColumnState({ state: state.columnState, applyOrder: true });
        }

        // ページ番号の復元（setTimeoutで遅延が安全）
        if (state.currentPage) {
          setTimeout(() => {
            this.grid.api.paginationGoToPage(state.currentPage);
          }, 100);
        }
      } catch (e) {
        console.warn('グリッド状態の復元に失敗:', e);
      }
    }

    this.isGridInitialized = true;
  }

  onFilterOrSortChanged(): void {
    if (!this.grid.api) return;
    if (!this.isGridInitialized) return;

    this.pageSize = this.grid.api.paginationGetPageSize();
    localStorage.setItem(this.gridPageSizeStorageKey, this.pageSize.toString());

    const state: MyGridState = {
      filterModel: this.grid.api.getFilterModel(),
      columnState: this.grid.api.getColumnState(),
      currentPage: this.grid.api.paginationGetCurrentPage()
    };

    localStorage.setItem(this.gridStateStorageKey, JSON.stringify(state));
  }

  ngOnInit(): void {
    this.pageSize = parseInt(localStorage.getItem(this.gridPageSizeStorageKey) ?? '100');
    this.showOnlyUnassigned = (localStorage.getItem(this.girdShowOnlyUnassignedStorageKey) === 'true');
    this.showCompleted = (localStorage.getItem(this.gridShowCompletedStorageKey) === 'true');
    this.category = this.route.snapshot.queryParamMap.get('category') as typeof InquiryCategory[number] ?? localStorage.getItem(this.categoryKey) as typeof InquiryCategory[number] ?? 'お問い合わせ'
    this.load();

    this.adminUsersService.getAdminUsers().subscribe(res => {
      this.adminUsers = this.adminUsersService.parseData(res);
      this.isLoaded = true;

      this.setFloatingOptions();
      this.showGrid = true;
    });
  }

  get subCategories() {
    return this.allRows ? [...new Set(this.allRows.map(x => x.sub_category).filter(x => !!x))] : [];
  }

  setFloatingOptions() {
    const admin_user_id_col: ColDef|undefined = this.columnDefs.find((x: ColDef) => x.field === 'admin_user_id');
    const status_col: ColDef|undefined = this.columnDefs.find((x: ColDef) => x.field === 'status');
    const sub_category_col: ColDef|undefined = this.columnDefs.find((x: ColDef) => x.field === 'sub_category');

    if (admin_user_id_col && status_col && sub_category_col) {

      admin_user_id_col.floatingFilterComponentParams = {
        filterType: 'equals',
        options: this.adminUsers.map(x => {
          return {label: x.user_name, value: x.id};
        })
      };

      status_col.floatingFilterComponentParams = {
        filterType: 'equals',
        options: this.InquiryStatusMap[this.category].map(x => {
          return {label: x, value: x};
        })
      };

      sub_category_col.floatingFilterComponentParams = {
        filterType: 'equals',
        options: this.subCategories
          .slice() // 元配列を壊さないため（重要）
          .sort((a, b) => a.localeCompare(b, 'ja'))
          .map(x => ({
            label: x,
            value: x
          }))
      };

      if (this.grid) {
        this.grid.api.setGridOption("columnDefs", this.columnDefs);
        this.grid.api.refreshHeader();
      }
    }
  }

  applyFilter(): void {
    this.rowData = this.allRows.filter(row => {
      // 「完了」フィルタ：false のときに「回答済」「完了」「取消」を除外
      if (!this.showCompleted && ['完了', '回答済', '処理済', '出金済', '取消'].includes(row.status)) {
        return false;
      }

      // 「未割当」フィルタ：true のときに admin_user_id が null のみ通す
      if (this.showOnlyUnassigned && row.admin_user_id !== null) {
        return false;
      }

      return true;
    });
  }

  onToggleOnlyAssigned(): void {
    localStorage.setItem(this.girdShowOnlyUnassignedStorageKey, this.showOnlyUnassigned.toString());
    this.applyFilter();
  }

  onToggleCompleted(): void {
    localStorage.setItem(this.gridShowCompletedStorageKey, this.showCompleted.toString());
    this.applyFilter();
  }

  load(): void {

    this.service.getAll(this.category, true).subscribe({
      next: (res) => {
        this.allRows = res;
        this.restoreGridState();
        this.applyFilter();
        localStorage.setItem(this.categoryKey, this.category);
        this.setFloatingOptions();
      },
      error: () => this.snackBar.show(this.category + '一覧の取得に失敗しました')
    });
  }

  onRowClicked(event: any): void {
    const id = event.data.id;
    sessionStorage.setItem(this.gridScrollStorageKey, String(id));
    this.router.navigate(['/admin/inquiry', id], {state: {subCategories: this.subCategories}});
  }

  download(e: Event) {
    const url = `${this.service.baseUrl}/table/${this.category}`;
    blankOpen(e, url);
  }
}
